import "./WishlistDrawer.css";

export default function WishlistDrawer({
  isOpen,
  wishlist,
  onRemove,
  onClose,
  onCheckout,
}) {
  return (
    <>
      <div
        className={`wishlist-overlay ${isOpen ? "show" : ""}`}
        onClick={onClose}
      ></div>

      <div className={`wishlist-drawer ${isOpen ? "open" : ""}`}>
        <div className="wishlist-header">
          <h2 className="wishlist-title">❤️ Your Wishlist</h2>
          <button className="wishlist-close" onClick={onClose}>
            ✖
          </button>
        </div>

        {wishlist.length === 0 ? (
          <p className="wishlist-empty">No friends added yet 😢</p>
        ) : (
          <>
            <ul className="wishlist-list">
              {wishlist.map((f) => (
                <li key={f.id} className="wishlist-item">
                <div className="wishlist-left">
                  <img src={f.photo} alt={f.name} />
                  <div className="wishlist-info">
                    <h3>{f.name}</h3>
                    <p>${f.income.toLocaleString()}</p>
                  </div>
                </div>
                <button onClick={() => onRemove(f.id)} className="remove-btn">✖</button>
              </li>
              
              ))}
            </ul>
            <button className="checkout-btn" onClick={onCheckout}>
              Proceed to Checkout 💌
            </button>
          </>
        )}
      </div>
    </>
  );
}
